import { render } from "./dashboard.vue?vue&type=template&id=10cc499a&scoped=true"
import script from "./dashboard.vue?vue&type=script&lang=js"
export * from "./dashboard.vue?vue&type=script&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=10cc499a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10cc499a"]])

export default __exports__